import { Youtube, SvgIcon } from '@cinch-labs/design-system'

import { useVehicleGallery, useModal } from '../../hooks'

import styles from './media.module.css'
import { getStoryblokImageServiceUrl } from '@cinch-nx/data-storyblok'
import { CarReviewV2Video } from '../../types/car-review-page'

export interface MediaProps {
  imageCount: number
  imageSrc: string
  title?: string
  alt: string | undefined
  video?: CarReviewV2Video[]
}

export const Media = ({
  imageCount,
  imageSrc,
  title,
  alt,
  video,
}: MediaProps) => {
  const { open } = useModal()
  const { setImageIndex, imageIndexes } = useVehicleGallery()

  const youtubeVideo: Partial<CarReviewV2Video> | null = video?.[0] ?? {}

  const { videoId, title: videoTitle, buttonLabel, thumbnail } = youtubeVideo
  const propsExist = videoId && videoTitle && buttonLabel && thumbnail?.filename

  const shouldShowImage = youtubeVideo && Object.keys(youtubeVideo).length === 0

  const getImageIndex = () => {
    switch (title) {
      case 'Interior': {
        return imageIndexes?.interiorSectionImageIndex || 0
      }
      case 'Performance': {
        return imageIndexes?.performanceSectionImageIndex || 0
      }
      case 'Practicality': {
        return imageIndexes?.practicalitySectionImageIndex || 0
      }
      case 'Running costs': {
        return imageIndexes?.runningCostsSectionImageIndex || 0
      }
      default: {
        return 0
      }
    }
  }

  const handleClick = async () => {
    if (title) {
      await setImageIndex(getImageIndex())
    }
    open()
  }

  return (
    <>
      <div className={styles.mediaContainer}>
        {shouldShowImage && imageSrc && (
          <button onClick={handleClick}>
            <img
              src={getStoryblokImageServiceUrl(imageSrc, {
                filters: [{ quality: 80 }],
              })}
              alt={alt}
              className={styles.mediaImage}
            />
            <span className={styles.mediaImageInfo}>
              <SvgIcon name="gallery" />
              Gallery ({imageCount})
            </span>
          </button>
        )}
      </div>
      <div className={styles.videoContainer}>
        {!shouldShowImage && propsExist && (
          <Youtube
            videoId={videoId}
            title={videoTitle}
            buttonLabel={buttonLabel}
            className={styles.video}
            customThumbnail={getStoryblokImageServiceUrl(
              thumbnail?.filename?.length ? thumbnail.filename : imageSrc,
              {
                filters: [{ quality: 80 }],
              },
            )}
            videoUrlOptions={{ autoplay: 1 }}
            showNewPlayIcon
          />
        )}
      </div>
    </>
  )
}
